import { Button, Checkbox, FormControlLabel, Grid, makeStyles, Typography } from '@material-ui/core'
import moment from 'moment';
import React from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { CboCentrosMedicos } from '../../cbos/CboCentrosMedicos';
import { CboEspecialidades } from '../../cbos/CboEspecialidades';
import { CboProfesionales } from '../../cbos/CboProfesionales';

const useStyles = makeStyles((theme) => ({
    buttons: {
        marginTop: "2rem",
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "space-around"
    },
    container: {
        backgroundColor: "#fff", marginTop: "1rem"
    },
    selects: {
        paddingRight: "1rem",
        paddingLeft: "1rem"
    }
}));

const SacarTurnoPaso2 = (props) => {
    const { idCentroMedico, idProfesional, idEspecialidad, virtual, primero, fechaNacimiento } = props
    const classes = useStyles()

    const handleSubmit = (e) => {
        e.preventDefault()
        if (primero) {
            props.handleChangeStep(3)
        } else {
            props.handleChangeStep(2)
        }
    }
    return (
        <Grid container className={classes.container}>
            <Grid item xs={12} >
                <ValidatorForm onSubmit={handleSubmit}>
                    <Grid container>
                        <Grid item xs={12} md={6} className={classes.selects}>
                            <CboEspecialidades
                                manejadorInputChange={(e) => {
                                    props.setearVariosValores({
                                        idEspecialidad: e.target.value,
                                        idCentroMedico: null,
                                        idProfesional: null
                                    })
                                }}
                                valor={idEspecialidad}
                                cargaAfiliado={true}
                                edadAfiliado={moment().diff(moment(fechaNacimiento), "years", false)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.selects}>
                            <CboCentrosMedicos
                                manejadorInputChange={props.handleInputChange}
                                valor={idCentroMedico}
                                idEspecialidad={idEspecialidad}
                                idProfesional={idProfesional}
                                cargarEnCascada={true}
                                cargaAfiliado={true}
                                filtrarPorUsuario={false}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.selects}>
                            <CboProfesionales
                                manejadorInputChange={props.handleInputChange}
                                valor={idProfesional}
                                idEspecialidad={idEspecialidad}
                                idCentroMedico={idCentroMedico}
                                cargarEnCascada={true}
                                cargaAfiliado={true}
                            />
                        </Grid>
                        <Grid item xs={null} md={6} />
                        <Grid item xs={12} md={6} className={classes.selects} style={{ marginTop: "1rem" }}>
                            <FormControlLabel
                                control={<Checkbox color="primary" checked={virtual} onChange={(e) => props.setearValor('virtual', e.target.checked)} name="virtual" />}
                                label={<Typography color="primary">Disponible para teleconsulta</Typography>}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} className={classes.selects} style={{ marginTop: "1rem" }}>
                            <FormControlLabel
                                control={<Checkbox color="primary" checked={primero} onChange={(e) => props.setearValor('primero', e.target.checked)} name="primero" />}
                                label={<Typography color="primary">Primero disponible</Typography>}
                            />
                        </Grid>
                        {/* <Grid item xs={12} className={classes.selects} style={{ marginTop: "1rem" }}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography color="primary" variant="body2" align="justify">Debido a la demanda contenida por varios meses y al cumplimiento de los protocolos establecidos para reducir el contagio por COVID-19, los turnos se otorgan más espaciados entre uno y otro para realizar tareas de desinfección, limpieza y ventilación en los consultorios.</Typography>
                                </CardContent>
                            </Card>
                        </Grid> */}
                    </Grid>

                    <div className={classes.buttons}>
                        <Button
                            type="button"
                            variant="contained"
                            color="secondary"
                            style={{textTransform:"none"}}
                            onClick={() => {
                                props.setearVariosValores({
                                    idEspecialidad: null,
                                    idCentroMedico: null,
                                    idProfesional: null,
                                    virtual: false,
                                    primero: false
                                })
                                props.handleChangeStep(0)
                            }}
                        >
                            Anterior
                    </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            style={{textTransform:"none"}}
                        >
                            Siguiente
                    </Button>
                    </div>
                </ValidatorForm>
            </Grid>
        </Grid>
    )
}

export default SacarTurnoPaso2
